<div class="hv-page">
  <div class="hv-card">
    <img
      class="hv-logo"
      src="../../../../../assets/theme/images/logo/NavBar.svg"
      width="56"
      height="56"
      alt="Creative Stall" />

    <p class="hv-brand">Creative Stall</p>
    <h1 class="hv-title">Verify you are human</h1>
    <p class="hv-copy">{{ statusText }}</p>

    <!-- Turnstile is mounted into #cf-turnstile-mount by the component (not Angular-bound). -->
    <div id="cf-turnstile-slot" class="hv-widget"></div>

    @if (errorText) {
      <p class="hv-error">{{ errorText }}</p>
    }

    @if (busy) {
      <p class="hv-hint">Please wait…</p>
    }
  </div>
</div>
